import { ValidationObserver, ValidationProvider } from "vee-validate";
import {MailingMethods} from "@/enums/MailingMethods";
import {MailingTypes} from "@/enums/MailingTypes";

export default {
  name: "AddMailingListDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      mailingTypes: MailingTypes,
      mailingMethods: MailingMethods,
      mailing: {
        facilityId: this.$store.state.authModule.currentFacility,
        name: "",
        type: MailingTypes.Custom,
        isSendToEmail: true,
        to: [],
        unsubscribed: [],
        method: MailingMethods.Automated,
      },
    }
  },
  methods: {
    open() {
      this.dialog = true;
      this.mailing.isSendToEmail = true;
    },
    async submit() {
      this.loading = true;

      if (this.mailing.type === this.mailingTypes.Custom) {
        this.mailing.method = this.mailingMethods.Manual;
      }

      if(this.mailingLists.find(x => x.name === this.mailing.name)){
        this.$refs.mailingName.applyResult({
          errors: [`${this.mailing.name} already created`],
          valid: false,
        });
        this.loading = false;
        return false;
      }

      await this.$store.dispatch("addFacilityMailingLists", this.mailing).then(data => {
        this.$router.push("/settings/mailingList/" + data.id.toString());
      });
      
      if(this.$refs.addMailingListForm){
        this.$refs.addMailingListForm.reset();
      }
      this.dialog = false;
      this.loading = false;
    },
  },
  computed: {
    mailingLists() {
      return this.$store.state.facilityModule.facilityMailingLists;
    },
  }
}